import { CreateCodeArguments } from '../../components/Homepage/CreateFlowcodeForm/CreateFlowcodeFormDesktop/CreateFlowcodeFormDesktop.hooks'
import { GENERATOR_FORM_CACHE_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { logger } from '@dtx-company/logger'

export async function setGeneratorFormCache({
  cacheKey,
  formValues
}: {
  cacheKey?: string
  formValues: CreateCodeArguments
}): Promise<boolean> {
  try {
    const params = new URLSearchParams()
    if (cacheKey) {
      params.set('cacheKey', cacheKey)
    }
    const query = cacheKey ? `?${params.toString()}` : ''
    const setCacheRes = await fetch(`${GENERATOR_FORM_CACHE_ENDPOINT}${query}`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({ formValues, cacheKey }),
      headers: {
        'Content-type': 'application/json'
      }
    })

    if (!setCacheRes.ok) {
      await logger.logFetchError(setCacheRes, { technicalArea: 'authentication' })
      return false
    }

    return setCacheRes.ok
  } catch (e) {
    logger.logError(e, { technicalArea: 'authentication' })
    return false
  }
}
